// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.thread-table-container {
  --table-bg-color: #fff;
  --table-border-color: var(--cui-border-color, #d8dbe0);
  --table-text-color: var(--cui-body-color, #4f5d73);
}
html[data-coreui-theme=dark] .thread-table-container {
  --table-bg-color: var(--cui-dark-bg-subtle, #1e1e2f);
  --table-border-color: var(--cui-dark-border-subtle, #333);
  --table-text-color: var(--cui-body-color, #fff);
}
.thread-table-container .table {
  border-color: var(--table-border-color) !important;
  width: 100%;
  margin-bottom: 0;
  color: var(--table-text-color);
}
.thread-table-container .table .table-header-cell {
  border-color: var(--table-border-color) !important;
  font-weight: 600;
}
.thread-table-container .table .table-header-cell.sortable-header {
  cursor: pointer;
}
.thread-table-container .table tbody tr {
  border-color: var(--table-border-color) !important;
}
.thread-table-container .table tbody tr:hover {
  border-color: var(--table-border-color) !important;
  background-color: inherit;
}
.thread-table-container .table tbody tr td {
  border-color: var(--table-border-color) !important;
}
.thread-table-container .card {
  border-color: var(--table-border-color) !important;
  background-color: var(--table-bg-color);
}
.thread-table-container .card .card-body {
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
}
.thread-table-container .table-hover tbody tr:hover {
  background-color: inherit !important;
  border-color: var(--table-border-color) !important;
  color: var(--table-text-color) !important;
}
.thread-table-container .table-hover tbody tr:hover td {
  color: var(--table-text-color) !important;
}
.thread-table-container .table-hover tbody tr:hover th {
  color: var(--table-text-color) !important;
}
.thread-table-container .pagination {
  margin-bottom: 0;
}
html[data-coreui-theme=dark] .thread-table-container .pagination {
  --cui-pagination-bg: var(--table-bg-color);
  --cui-pagination-color: var(--table-text-color);
  --cui-pagination-active-bg: var(--cui-primary);
  --cui-pagination-active-color: var(--table-text-color);
  --cui-pagination-disabled-bg: var(--table-bg-color);
  --cui-pagination-disabled-color: var(--cui-secondary-color);
  --cui-pagination-border-color: var(--table-border-color);
}
html[data-coreui-theme=dark] .thread-table-container .form-select {
  background-color: var(--table-bg-color);
  color: var(--table-text-color);
  border-color: var(--table-border-color);
}
.thread-table-container .d-flex.justify-content-between.align-items-center.mt-3 {
  margin-top: 1rem;
}
.thread-table-container .cursor-pointer {
  cursor: pointer;
  display: flex;
  justify-content: center;
}
.thread-table-container .cursor-pointer:hover {
  opacity: 0.8;
}
.thread-table-container .text-center {
  text-align: center;
  padding: 1.5rem;
  font-style: italic;
}
.thread-table-container .badge-success {
  background-color: var(--cui-success) !important;
  color: #fff;
}
.thread-table-container .badge-danger {
  background-color: var(--cui-danger) !important;
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/components/ThreadTable/ThreadTable.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,sDAAA;EACA,kDAAA;AACF;AACE;EACE,oDAAA;EACA,yDAAA;EACA,+CAAA;AACJ;AAEE;EACE,kDAAA;EACA,WAAA;EACA,gBAAA;EACA,8BAAA;AAAJ;AAEI;EACE,kDAAA;EACA,gBAAA;AAAN;AAEM;EACE,eAAA;AAAR;AAII;EACE,kDAAA;AAFN;AAIM;EACE,kDAAA;EACA,yBAAA;AAFR;AAKM;EACE,kDAAA;AAHR;AAQE;EACE,kDAAA;EACA,uCAAA;AANJ;AAQI;EACE,uCAAA;EACA,8BAAA;AANN;AAUE;EACE,oCAAA;EACA,kDAAA;EACA,yCAAA;AARJ;AAUI;EACE,yCAAA;AARN;AAWI;EACE,yCAAA;AATN;AAaE;EACE,gBAAA;AAXJ;AAeI;EACE,0CAAA;EACA,+CAAA;EACA,8CAAA;EACA,sDAAA;EACA,mDAAA;EACA,2DAAA;EACA,wDAAA;AAbN;AAgBI;EACE,uCAAA;EACA,8BAAA;EACA,uCAAA;AAdN;AAkBE;EACE,gBAAA;AAhBJ;AAmBE;EACE,eAAA;EACA,aAAA;EACA,uBAAA;AAjBJ;AAmBI;EACE,YAAA;AAjBN;AAqBE;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;AAnBJ;AAsBE;EACE,+CAAA;EACA,WAAA;AApBJ;AAuBE;EACE,8CAAA;EACA,WAAA;AArBJ","sourcesContent":[".thread-table-container {\n  --table-bg-color: #fff;\n  --table-border-color: var(--cui-border-color, #d8dbe0);\n  --table-text-color: var(--cui-body-color, #4f5d73);\n\n  html[data-coreui-theme=\"dark\"] & {\n    --table-bg-color: var(--cui-dark-bg-subtle, #1e1e2f);\n    --table-border-color: var(--cui-dark-border-subtle, #333);\n    --table-text-color: var(--cui-body-color, #fff);\n  }\n\n  .table {\n    border-color: var(--table-border-color) !important;\n    width: 100%;\n    margin-bottom: 0;\n    color: var(--table-text-color);\n\n    .table-header-cell {\n      border-color: var(--table-border-color) !important;\n      font-weight: 600;\n\n      &.sortable-header {\n        cursor: pointer;\n      }\n    }\n\n    tbody tr {\n      border-color: var(--table-border-color) !important;\n\n      &:hover {\n        border-color: var(--table-border-color) !important;\n        background-color: inherit;\n      }\n\n      td {\n        border-color: var(--table-border-color) !important;\n      }\n    }\n  }\n\n  .card {\n    border-color: var(--table-border-color) !important;\n    background-color: var(--table-bg-color);\n\n    .card-body {\n      background-color: var(--table-bg-color);\n      color: var(--table-text-color);\n    }\n  }\n\n  .table-hover tbody tr:hover {\n    background-color: inherit !important;\n    border-color: var(--table-border-color) !important;\n    color: var(--table-text-color) !important;\n    \n    td {\n      color: var(--table-text-color) !important;\n    }\n    \n    th {\n      color: var(--table-text-color) !important;\n    }\n  }\n\n  .pagination {\n    margin-bottom: 0;\n  }\n\n  html[data-coreui-theme=\"dark\"] & {\n    .pagination {\n      --cui-pagination-bg: var(--table-bg-color);\n      --cui-pagination-color: var(--table-text-color);\n      --cui-pagination-active-bg: var(--cui-primary);\n      --cui-pagination-active-color: var(--table-text-color);\n      --cui-pagination-disabled-bg: var(--table-bg-color);\n      --cui-pagination-disabled-color: var(--cui-secondary-color);\n      --cui-pagination-border-color: var(--table-border-color);\n    }\n\n    .form-select {\n      background-color: var(--table-bg-color);\n      color: var(--table-text-color);\n      border-color: var(--table-border-color);\n    }\n  }\n\n  .d-flex.justify-content-between.align-items-center.mt-3 {\n    margin-top: 1rem;\n  }\n\n  .cursor-pointer {\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n\n    &:hover {\n      opacity: 0.8;\n    }\n  }\n\n  .text-center {\n    text-align: center;\n    padding: 1.5rem;\n    font-style: italic;\n  }\n\n  .badge-success {\n    background-color: var(--cui-success) !important;\n    color: #fff;\n  }\n\n  .badge-danger {\n    background-color: var(--cui-danger) !important;\n    color: #fff;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
